document.addEventListener('DOMContentLoaded', function () {
  const cinbox = document.querySelector('.cinbox')

  if (cinbox) {
    const paragraphs = cinbox.querySelectorAll('p')

    // Mostra il pulsante "Leggi tutto" solo se ci sono più di 3 paragrafi
    if (paragraphs.length > 3) {
      // Nasconde i paragrafi dal quarto in poi
      for (let i = 3; i < paragraphs.length; i++) {
        paragraphs[i].classList.add('extra-paragraph')
        paragraphs[i].style.display = 'none'
      }

      // Crea il pulsante "Leggi tutto"
      const readMoreButton = document.createElement('a')
      readMoreButton.className = 'hbox-readmore-toggle hbox-readmore-toggle--showmore'
      readMoreButton.href = '#'
      readMoreButton.innerHTML = `
                <div class="hbox-readmore-toggle__content">
                    <span class="hbox-readmore-toggle__text">Mostra tutto</span>
                    <span class="hbox-readmore-toggle__icon material-icons">keyboard_arrow_down</span>
                </div>
            `

      // Inserisce il pulsante subito dopo il terzo <p>
      paragraphs[2].insertAdjacentElement('afterend', readMoreButton)

      // Aggiunge evento al pulsante per mostrare/nascondere i paragrafi extra
      readMoreButton.addEventListener('click', function (event) {
        event.preventDefault()
        cinbox.classList.toggle('expanded')

        // Cambia il testo e l'icona del pulsante
        const toggleText = readMoreButton.querySelector('.hbox-readmore-toggle__text')
        const toggleIcon = readMoreButton.querySelector('.hbox-readmore-toggle__icon')
        if (cinbox.classList.contains('expanded')) {
          toggleText.innerText = 'Mostra meno'
          toggleIcon.innerText = 'keyboard_arrow_up'

          // Mostra tutti i paragrafi nascosti
          document.querySelectorAll('.extra-paragraph').forEach(p => {
            p.style.display = 'block'
          })
        } else {
          toggleText.innerText = 'Mostra tutto'
          toggleIcon.innerText = 'keyboard_arrow_down'

          // Nasconde di nuovo i paragrafi extra
          document.querySelectorAll('.extra-paragraph').forEach(p => {
            p.style.display = 'none'
          })
        }

        // Sposta il pulsante sotto l'ultimo <p> se espanso
        if (cinbox.classList.contains('expanded')) {
          paragraphs[paragraphs.length - 1].insertAdjacentElement('afterend', readMoreButton)
        } else {
          // Se ridotto, riporta il pulsante dopo il terzo <p>
          paragraphs[2].insertAdjacentElement('afterend', readMoreButton)
        }
      })
    }
  }
})
